import type { Termino } from '../api/estructura'

/**
 * Lo puro de los términos en el panel: los ids elegidos de un campo `terminos` (lleguen como
 * id o poblados) y el nombre de cada término con sus madres («Lima › Miraflores»), que es como
 * se distinguen dos «Centro» de ramas distintas.
 */
export const idsDeTerminos = (valor: unknown): number[] =>
  Array.isArray(valor)
    ? valor.flatMap((v) => (typeof v === 'number' ? [v] : v && typeof v === 'object' && typeof (v as { id?: unknown }).id === 'number' ? [(v as { id: number }).id] : []))
    : []

const idDeMadre = (t: Pick<Termino, 'padre'>): null | number => (typeof t.padre === 'number' ? t.padre : t.padre && typeof t.padre === 'object' ? t.padre.id : null)

/** Por id, el nombre con sus madres, hasta cuatro niveles (el tope de la jerarquía); un ciclo no se recorre dos veces. */
export const nombresConMadre = (terminos: Array<Pick<Termino, 'id' | 'nombre' | 'padre'>>): Map<number, string> => {
  const porId = new Map(terminos.map((t) => [t.id, t]))
  const salida = new Map<number, string>()
  for (const t of terminos) {
    const partes = [t.nombre]
    const vistos = new Set([t.id])
    let madre = idDeMadre(t)
    while (madre !== null && !vistos.has(madre) && partes.length < 4) {
      const m = porId.get(madre)
      if (!m) break
      partes.unshift(m.nombre)
      vistos.add(m.id)
      madre = idDeMadre(m)
    }
    salida.set(t.id, partes.join(' › '))
  }
  return salida
}
